import { getListBrowserStore } from '@ts-private/list-browser';
export const leasingExpenseTypesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'expenseCode',
      caption: 'LeasingExpenseType.ExpenseCode',
      type: 'text'
    },
    {
      name: 'expenseName',
      caption: 'LeasingExpenseType.ExpenseName',
      type: 'text'
    },
    {
      name: 'isActive',
      caption: 'LeasingExpenseType.IsActive',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'LeasingExpenseType.ExpenseCode',
      value: 'LeasingExpenseCode'
    },
    {
      caption: 'LeasingExpenseType.ExpenseName',
      value: 'LeasingExpenseName'
    }
  ],
  pager: {
    orderBy: 'LeasingExpenseName',
    direction: 'asc'
  }
});
